var usernameRegex = /^(?=[a-zA-Z0-9_\-.]*[a-zA-Z])[a-zA-Z0-9_\-.]{5,50}$/;
usernameRegex.description = "\n  Must be 8 to 98 characters long,\n  contain letters,\n  consist only of letters, numbers, and/or special characters in the following list _ - .\n";
var passwordLengthRegex = /^.{8,98}$/;
passwordLengthRegex.description = 'Be 8 to 98 characters long';
var passwordLowercase = /[a-z]/;
passwordLowercase.description = 'Contain lowercase letters';
var passwordUpperCase = /[A-Z]/;
passwordUpperCase.description = 'Contain uppercase letters';
var passwordNumbers = /[0-9]/;
passwordNumbers.description = 'Contain numbers';
var passwordSpecialChars = /[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`]/;
// eslint-disable-next-line operator-linebreak
passwordSpecialChars.description =
    'Contain special characters in the following list ^ $ * . [ ] { } ( ) ? " ! @ # % & / \\ , > < \' : ; | _ ~ `';
/**
 * Each regex has extra 'description' prop
 */
var passwordRegexes = [
    passwordLengthRegex,
    passwordLowercase,
    passwordUpperCase,
    passwordNumbers,
    passwordSpecialChars,
];
var getPasswordRegexErrors = function (password) {
    var errors = [];
    passwordRegexes.forEach(function (regex) {
        if (!regex.test(password)) {
            errors.push(regex.description);
        }
    });
    return errors.join(', ');
};
var getPasswordError = function (password, passwordAgain) {
    var passwordRegexErrors = getPasswordRegexErrors(password);
    if (password.length < 1 || passwordAgain.length < 1) {
        return 'Password, and Confirm Password are required';
    }
    if (passwordRegexErrors) {
        return "Password must conform to the following: ".concat(passwordRegexErrors);
    }
    if (password !== passwordAgain) {
        return 'Passwords do not match.';
    }
    return null;
};
var looselyEmailRegex = /^.+@.+\..+$/;
/**
 * Checks if input parses as an int and looks like an int when cast to string
 */
var isLooselyInt = function (mixed) {
    var int = parseInt(mixed, 10);
    if (Number.isNaN(int) || mixed.toString() !== int.toString()) {
        return false;
    }
    return true;
};
export { usernameRegex, passwordRegexes, getPasswordRegexErrors, getPasswordError, looselyEmailRegex, isLooselyInt, };
